"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CompletionIndex_1 = require("../models/CompletionIndex");

var SearchResult_1 = require("../models/SearchResult");

var HintLexer_1 = require("./HintLexer");

var hintUtils_1 = require("./hintUtils");

function isIdentifier(token) {
  if (!token) {
    return false;
  }

  return token.type === 'identifier' || token.type === 'keyword';
}

function isWhitespace(token) {
  return !token || token.type === 'whitespace';
}

function startState(lexer) {
  var token = lexer.peek();

  while (isWhitespace(token)) {
    if (lexer.done()) {
      return endState;
    }

    lexer.ignore();
    token = lexer.peek();
  }

  if (isIdentifier(token)) {
    return identifierState;
  }

  return endState;
}

function endState() {
  return endState;
}

function identifierState(lexer) {
  var lastToken = lexer.pop();

  if (lastToken) {
    lexer.emit(lastToken);
  }

  var token = lexer.peek();

  while (isWhitespace(token)) {
    if (lexer.done()) {
      return endState;
    }

    lexer.ignore();
    token = lexer.peek();
  }

  return endState;
}

exports.hintOnWord = function (editor, index, options) {
  var position = editor.getDoc().getCursor();
  var tokens = hintUtils_1.iterateTokensReverse(editor, position);
  var identifierTokens = [];

  var onEmitIdentifier = function onEmitIdentifier(token) {
    return identifierTokens.unshift(token);
  };

  var lexer = new HintLexer_1.HintLexer(tokens, onEmitIdentifier);
  var state = startState;

  while (state !== endState) {
    state = state(lexer);
  }

  var path = identifierTokens.map(function (token) {
    return token.token;
  });
  var hints = CompletionIndex_1.CompletionIndex.search(index, path, options);
  var from = identifierTokens[0] ? identifierTokens[0].start : position;
  var to = position;
  return SearchResult_1.SearchResult.create(hints, from, to);
};